
function initHome() {
    require(['jquery', 'Seed', 'Seed.Tab', 'Seed.Ajax', 'bootbox'], function ($, Seed) {
        var racAndIndicators = $('#racAndIndicatorsContainer');
        var chartContainer = $('#homeContainer');
        $(racAndIndicators).remove();
        $(chartContainer).remove();
        racAndIndicators = document.createElement('DIV');
        racAndIndicators.setAttribute('class', 'row');
        racAndIndicators.setAttribute('id', 'racAndIndicatorsContainer');
        chartContainer = document.createElement('DIV');
        chartContainer.setAttribute('class', 'row');
        chartContainer.setAttribute('id', 'homeContainer');
        $('#accueil_frame').append(racAndIndicators).append(chartContainer);
        Seed.Ajax.Post({
            url: 'homeController.php',
            async: true,
            success: function (response) {
                var newResponse = JSON.parse(response);
                racAndIndicators = $('#racAndIndicatorsContainer');
                $(newResponse['shortcuts']).appendTo(racAndIndicators);
                $(newResponse['indicators']).appendTo(racAndIndicators);
                chartContainer = $('#homeContainer');
                $(newResponse['charts']).appendTo(chartContainer);
            }
        });
    });
}

function chartAjaxCall(chartId, forHomeContainer) {
    require(['jquery', 'Seed', 'Seed.Tab', 'Seed.Ajax'], function ($, Seed) {
        var tempChartId = chartId.split("chart");
        var chartFinalId = tempChartId[1];
        var container = $('#' + chartId);
        var data = {
            myChartId: chartFinalId
        };
        if (forHomeContainer === 'true') {
            Seed.Ajax.Post({
                url: 'homeController.php',
                async: true,
                data: data,
                success: function (response) {
                    $(response).appendTo(container);
                }
            });
        }
    });
}

function createChart(canvasId, graphType, graphName, graphLabels, curveTension, com0, colorSet, graphDataSet, graphDataLabelSet, hasToFillArea) {
    require(["Chartjs", "moment"], function (Chart) {
        var ctx = document.getElementById(canvasId);
        var dataInfo = {};
        var dontDisplay = "";
        var toolTip = "";
        graphName = JSON.parse(graphName);
        graphLabels = JSON.parse(graphLabels);
        graphDataSet = JSON.parse(graphDataSet);
        graphDataLabelSet = JSON.parse(graphDataLabelSet);
        if (graphType === 'pie' || graphType === 'doughnut') {
            dataInfo = generatePieOrDoughnut(graphDataSet, colorSet);
            dontDisplay = [{display: false}];
            toolTip = {enabled: true};
        } else {
            dataInfo = generateStandard(graphLabels, graphDataSet, colorSet, curveTension, graphType, hasToFillArea);
            toolTip = {enabled: true, mode: 'x-axis'};
        }
        var startPoint = com0 === "1" ? [{ticks: {beginAtZero: true}}] : "";
        new Chart(ctx, {type: graphType,
            data: {labels: graphDataLabelSet,
                datasets: dataInfo},
            options: {scales: {xAxes: dontDisplay,
                    yAxes: startPoint
                },
                legend: {display: true,
                    position: 'bottom'
                },
                title: {display: true,
                    text: graphName,
                    fontSize: 20,
                    fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
                },
                tooltips: toolTip,
                showTooltips: true,
                animation: false
            }
        });
    });
}

function generatePieOrDoughnut(graphDataSet, colorSet) {
    var finalArray = [];
    var tempColorSet = colorSet.split('-');
    for (var counter = 0; counter < graphDataSet.length; counter++) {
        var myData = stringToArray(graphDataSet[counter]);
        var finalColorSet = tempColorSet;

        var datasets = {data: myData,
            backgroundColor: finalColorSet
        };
        finalArray.push(datasets);
    }
    return finalArray;

}

function generateStandard(graphLabels, graphDataSet, colorSet, curveTension, graphType, hasToFillArea) {
    var finalArray = [];
    for (var counter = 0; counter < graphDataSet.length; counter++) {
        var myLabel = stringToArray(graphLabels[counter]);
        var myData = stringToArray(graphDataSet[counter]);
        var tempColorSet = colorSet.split('-');
        var finalColorSet;
        if (graphType !== 'bar') {
            finalColorSet = tempColorSet[counter];
        } else if (graphType === 'bar') {
            for (var j = 0; j < graphDataSet[counter].split(',').length; j++) {
                if (typeof tempColorSet[counter] === 'string') {
                    finalColorSet = tempColorSet[counter];
                }
            }
        }
        var myBackgroundColor = [];
        myBackgroundColor = finalColorSet;
        if(hasToFillArea === "1"){
            hasToFillArea = true;
        }else{
            hasToFillArea = false;
        }
        var datasets = {label: myLabel,
            data: myData,
            backgroundColor: myBackgroundColor,
            lineTension: curveTension,
            fill: hasToFillArea,
            borderWidth: 1};
        finalArray.push(datasets);
    }
    return finalArray;
}


function stringToArray(myString) {
    var splittedString = myString.split(',');
    return splittedString;
}

function changeAlink(chartId, toDownload) {
    if (window.foo === undefined) {
        if (toDownload) {
            var realChartId = chartId.split('-');
            var context = document.getElementById(realChartId[1]).toDataURL();
            var newContext = context.replace("image/png", "image/octet-stream");
            $('#' + chartId).children('a').prop('href', newContext);
        }
        window.foo = 'changeAlink';
        var aId = '';
        if (toDownload) {
            aId = 'link-' + realChartId[1];
            $('#' + chartId).children('a').css('visibility', 'visible');
            document.getElementById(aId).click();
            $('#' + chartId).children('a').css('visibility', 'hidden');
        } else {
            var aLink = document.getElementById(chartId).children;
            aLink[1].style.visibility = 'visible';
            aLink[1].click();
            aLink[1].style.visibility = 'hidden';
        }

        window.foo = undefined;
    }
}

function JSONToCSV(JSONData, reportTitle) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';
    reportTitle = JSON.parse(reportTitle);

    CSV += reportTitle + '\r\n\n';

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
        var row = "";

        //2nd loop will extract each column and convert it in string separated by semi-column
        for (var index in arrData[i]) {
            row += '"' + arrData[i][index] + '";';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + '\r\n';
    }

    //Generate a file name
    var fileName = "graphique_";
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += reportTitle.replace(/ /g, "_");

    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    //this trick will generate a temp <a /> tag
    var linkContainer = document.getElementById(reportTitle);
    var link = document.createElement('a');
    link.href = uri;
    link.target = '_blank';

    link.download = fileName + '_' + new Date() + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    linkContainer.appendChild(link);
};
define("homeController", function(){});

